const inventoryEn = {
    brand: require('../../lang/en/inventory/Brand').default,
    color: require('../../lang/en/inventory/Color').default,
    deliveryNote: require('../../lang/en/inventory/DeliveryNote').default,
    invoice: require('../../lang/en/inventory/Invoice').default,
    item: require('../../lang/en/inventory/Item').default,
    measureUnit: require('../../lang/en/inventory/MeasureUnit').default,
    measureUnitType: require('../../lang/en/inventory/MeasureUnitType').default,
    payment: require('../../lang/en/inventory/Payment').default,
    pricingMaster: require('../../lang/en/inventory/PricingMaster').default,
    rack: require('../../lang/en/inventory/Rack').default,
    segment: require('../../lang/en/inventory/Segment').default,
    subCategory: require('../../lang/en/inventory/SubCategory').default,
};

export default inventoryEn;